import { createContext } from 'react';

export const PostContext = createContext();
// export const CommentContext = createContext();
